// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import { Tabs } from 'components/shared/Tabs/Tabs'
import { TabContent } from './common/TabContent/TabContent'
import { FeatureFlag } from 'components/auth/FeatureFlag'
import { useTabScrollIntoView } from 'hooks'
import { ALIGNMENT_NAMES } from './model'

import styles from './TabsBar.module.scss'

export const TabsBar = ({
  activeTab,
  alignment,
  className = undefined,
  tabClassName = undefined,
  tabs,
  onClick,
  isScrollable,
  isCentered,
  isOutlined,
}) => {
  const ref = useTabScrollIntoView(activeTab)

  return (
    <Tabs
      className={cx(styles.tabsBar, styles.alignment, className, {
        [styles['top-left']]: R.equals(alignment, ALIGNMENT_NAMES.TOP_LEFT),
        [styles.centered]: isCentered,
        [styles.outlined]: isOutlined,
      })}
      isScrollable={isScrollable}
    >
      {R.map(
        ({
          id,
          label,
          sequenceNumber,
          isDisabled,
          isFinished,
          isInvalid,
          adminOnly,
          caution,
        }) => {
          const isActiveTab = R.equals(activeTab, id)

          const tabComponent = (
            <Tabs.Tab
              {...(R.not(isDisabled) && { onClick: () => onClick(id) })}
              className={cx(styles.tab, tabClassName, {
                [styles.active]: isActiveTab,
                [styles.invalid]: isInvalid,
              })}
              key={id}
              ref={isActiveTab ? ref : null}
              {...{ id, isDisabled }}
            >
              <TabContent
                className={styles.content}
                isActive={isActiveTab}
                {...{
                  label,
                  sequenceNumber,
                  isDisabled,
                  isFinished,
                  isInvalid,
                  caution,
                }}
              />
            </Tabs.Tab>
          )

          if (adminOnly) {
            return <FeatureFlag key={id} accountAdmin>{tabComponent}</FeatureFlag>
          }

          return tabComponent
        },
        tabs,
      )}
    </Tabs>
  )
}
